export default {
  namespaced: true,
  state: {
    config: null
  },
  getters: {
    config: state => state.config
  },
  mutations: {
    setConfig (state, value) {
      state.config = value
    }
  },
  actions: {
    load (context) {
      let config = JSON.parse(`${process.env.VUE_APP_SITE_CONFIGURATION}`)
      context.commit('setConfig', config)
    }
  }
}
